module.exports = __webpack_public_path__ + "static/media/arab28.fc2f14bf.wav";